module.exports = __webpack_public_path__ + "static/img-main-b590f6f9db5b95bc34079d357bc023da.jpg";